import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageModel, ImageModelSchema } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCulinaryStudioServiceApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        title: z.string(),
        description: z.any().optional().nullable(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});

type GetCulinaryStudioServiceApiResponse
    = ApiResponse<z.infer<typeof GetCulinaryStudioServiceApiResponseSchema>>;

type GetCulinaryStudioServiceActionRequest = undefined

export const getCulinaryStudioService = createAsyncThunk<
    GetCulinaryStudioServiceApiResponse | BaseError,
    GetCulinaryStudioServiceActionRequest
>(
    'CulinaryStudioPageActionsGetCulinaryStudioService',
    async () => apiInstance.get(
        '/culinary-studio-service',
        {
            'populate[image][fields]': 'url',
        },
        GetCulinaryStudioServiceApiResponseSchema,
    ),
);

export const GetCulinaryStudioServiceActionResponseMapper = {
    getImage: (
        { data }: GetCulinaryStudioServiceApiResponse,
    ): ImageModel => ImageModelSchema.parse({
        url: data.data.image?.url,
    }),

    getTitle: (
        { data }: GetCulinaryStudioServiceApiResponse,
    ): string => data.data.title,

    getDescription: (
        { data }: GetCulinaryStudioServiceApiResponse,
    ): any => data.data.description,
};
